import userService from 'resources/user/user.service';
import * as companyApi from 'resources/company/company.api';

export const reactivateTeamMember = async ({ id }) => {
  const updatedUser = await userService.updateUser({
    id,
    is_deactivated: false,
  });

  await companyApi.actualizeSubscriptionQty();

  return updatedUser;
};
